import React, { useState, useEffect } from 'react'
import validate from 'validate.js'
import { useSessionService } from 'hooks/useSessionService'
import { TextField, Grid, Typography } from '@material-ui/core'
import { ModalConfirmacao } from 'components/ModalConfirmacao'
import LockIcon from '@material-ui/icons/LockOutlined'
import { useAuth } from 'hooks/useAuth'
import useStyles from './styles'

const schema = {
  cpf: {
    format: {
      pattern: '([0-9]{2}[.]?[0-9]{3}[.]?[0-9]{3}[/]?[0-9]{4}[-]?[0-9]{2})|([0-9]{3}[.]?[0-9]{3}[.]?[0-9]{3}[-]?[0-9]{2})',
      message: '^Digite um CPF válido',
    },
    presence: { allowEmpty: false, message: '^CPF é obrigatório' },
  },
  senha: {
    presence: { allowEmpty: false, message: '^Senha é obrigatório' },
    length: {
      minimum: 8,
      message: '^No mínimo 8 caracteres',
    },
  },
}

export const ConfirmarIdentidade = (props) => {
  const { currentUser } = useAuth()
  const { aberto, setAberto, processando, disabled = false, callback, titulo, CPFparaValidacao, failback } = props
  const [processandoOperacao, setProcesandoOperacao] = useState(false)
  const classes = useStyles()
  const sessionService = useSessionService()

  const [formState, setFormState] = useState({
    isValid: false,
    values: {
      cpf: CPFparaValidacao || currentUser.cpf,
    },
    touched: {},
    errors: {},
    cpfValido: true,
  })

  const [isLoginErrado, setIsLoginErrado] = useState(false)

  const fecharModal = () => {
    setIsLoginErrado(false)
    setAberto(false)
    setFormState((formState) => ({
      ...formState,
      isValid: false,
      values: {},
      touched: {},
      errors: {},
      cpfValido: false,
    }))
  }

  useEffect(() => {
    const errors = validate(formState.values, schema)

    setFormState((formState) => ({
      ...formState,
      isValid: !errors,
      errors: errors || {},
    }))
  }, [formState.values])

  const handleChange = (event) => {
    event.persist()
    setFormState((formState) => ({
      ...formState,
      values: {
        ...formState.values,
        [event.target.name]: event.target.type === 'checkbox' ? event.target.checked : event.target.value,
      },
      touched: {
        ...formState.touched,
        [event.target.name]: true,
      },
    }))
  }

  const handleSubmit = async () => {
    setProcesandoOperacao(true)
    setIsLoginErrado(false)

    try {
      const response = await sessionService.autenticar({ ...formState.values, cpf: CPFparaValidacao || currentUser.cpf })

      if (response.data) {
        await callback()
        fecharModal()
      } else {
        setIsLoginErrado(true)
      }
    } catch (error) {
      setIsLoginErrado(true)
    }

    setProcesandoOperacao(false)
  }

  const hasError = (field) => formState.touched[field] && formState.errors[field]

  return (
    <ModalConfirmacao
      aberto={aberto}
      onClose={() => {
        if (failback) failback()
        fecharModal()
      }}
      onConfirm={handleSubmit}
      processando={processandoOperacao}
      disabled={!formState.isValid || disabled || processando}
      titulo={titulo || 'Confirmar Identidade'}
      confirmarLabel="Assinar"
      cancelarLabel="Cancelar"
      confirmarColor="secondary"
      maxWidth="xs"
    >
      <Grid container spacing={2}>
        <Grid item xs={12} style={{ display: 'flex', alignItems: 'flex-start', gap: '12px', paddingBottom: '15px' }}>
          <LockIcon color="action" style={{ marginTop: '2px' }} />
          <Typography variant="body2" color="textSecondary">
            Esta operação requer autenticação. Confirme sua senha de acesso para completar a operação.
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <TextField
            label="CPF"
            name="cpf"
            disabled
            value={CPFparaValidacao || currentUser.cpf}
            variant="outlined"
            fullWidth
            required
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            error={hasError('senha')}
            helperText={hasError('senha') ? formState.errors.senha[0] : null}
            label="Senha"
            name="senha"
            onChange={handleChange}
            type="password"
            value={formState.values.senha || ''}
            variant="outlined"
            fullWidth
            required
            onKeyPress={(e) => {
              if (e.key === 'Enter' && formState.isValid && !processandoOperacao) {
                handleSubmit()
              }
            }}
          />
        </Grid>

        {isLoginErrado && (
          <Grid item xs={12}>
            <Typography color="error" align="center" variant="body2">
              CPF e/ou senha incorretos
            </Typography>
          </Grid>
        )}
      </Grid>
    </ModalConfirmacao>
  )
}
export default ConfirmarIdentidade
